import { Transform } from 'class-transformer';
import { IsDateString, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

import { DeliveryAddressModel } from '../delivery-address.model';
import { ShippingSettingsModel } from '../shipping-settings.model';
import { extractPlainDate, sanitizeString } from '../utils';

export class SubmitDraftDto {
  @IsOptional()
  @IsDateString()
  @IsNotEmpty()
  @Transform(({ value }) => extractPlainDate(value))
  public dueDate?: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public customerPoNumber?: string;

  @IsOptional()
  @IsNotEmpty()
  public deliveryAddress?: DeliveryAddressModel;

  @IsOptional()
  @IsNotEmpty()
  public shippingSettings?: ShippingSettingsModel;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(50)
  public contactId?: string;
}
